var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Entity, Identifier } from 'ddd-base';
import { DateTime } from 'luxon';
var NotificationIdentifier = /** @class */ (function (_super) {
    __extends(NotificationIdentifier, _super);
    function NotificationIdentifier() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NotificationIdentifier;
}(Identifier));
export { NotificationIdentifier };
/**
 * 一件のお知らせ
 */
var Notification = /** @class */ (function (_super) {
    __extends(Notification, _super);
    function Notification() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Notification.prototype, "id", {
        // お知らせID
        get: function () {
            return this.props.id.toValue();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Notification.prototype, "title", {
        // タイトル
        get: function () {
            var _a;
            return (_a = this.props.title) !== null && _a !== void 0 ? _a : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Notification.prototype, "message", {
        // 本文
        get: function () {
            var _a;
            return (_a = this.props.message) !== null && _a !== void 0 ? _a : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Notification.prototype, "openedAt", {
        // 公開開始日時
        get: function () {
            var _a;
            return (_a = this.props.openedAt) !== null && _a !== void 0 ? _a : DateTime.now();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Notification.prototype, "updatedAt", {
        // 最終更新日時
        get: function () {
            var _a;
            return (_a = this.props.updatedAt) !== null && _a !== void 0 ? _a : DateTime.now();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Notification.prototype, "alreadyRead", {
        // お知らせが既読であるか
        get: function () {
            var _a;
            return (_a = this.props.alreadyRead) !== null && _a !== void 0 ? _a : false;
        },
        enumerable: false,
        configurable: true
    });
    // 既読状態を更新
    Notification.prototype.updateAlreadyRead = function (alreadyRead) {
        return new Notification(__assign(__assign({}, this.props), { alreadyRead: alreadyRead }));
    };
    return Notification;
}(Entity));
export { Notification };
